// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"033a32b8","906":"8d67cb82"}[chunkId] + ".chunk.js";
};